import React, { useState } from "react";
import { useOutletContext } from "react-router";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import utc from "dayjs/plugin/utc";

import DataFetcher from "../../../components/DataFetcher";
import { OutlineButton } from "../../../components/Button";
import AddressUpdateDetailsModal from "./AddressUpdateDetailsModal";
import { formatAccts } from "../../../utils/helpers";

dayjs.extend(advancedFormat);
dayjs.extend(utc);

const AddressUpdateRequestsPage = () => {
  const [setPageTitle] = useOutletContext();
  setPageTitle("Address Updates");

  return (
    <DataFetcher
      url={`/address-updates`}
      buildUI={(data, mutate) => (
        <AddressUpdateRequestsDisplay requests={data} mutate={mutate} />
      )}
    />
  );
};

const AddressUpdateRequestsDisplay = ({ requests, mutate }) => {
  const [selectedReqIndex, setSelectedReqIndex] = useState(-1);

  return (
    <div>
      <h2 className="fs-20 mb-16">Address Update Requests</h2>

      <div className="box">
        {!requests || requests.length === 0 ? (
          <>There is currently no address updates requests</>
        ) : (
          requests.map((req, i) => (
            <div key={i} className="flex center gap info-row-with-actions">
              <div className="text">
                <h3 className="fs-20">
                  {req.customerName}
                  <span className="btn primary light fs-14 no-hover">
                    Tier {req.accountTier}
                  </span>
                </h3>
                <p className="charcoal-60">{formatAccts(req.accountNumbers)}</p>
                <p className="charcoal-60">
                  {dayjs(req.timestamp * 1000).utc().format("D - MMM - YYYY")}
                  &nbsp;&bull;&nbsp;
                  {dayjs(req.timestamp * 1000).utc().format("hh:mm")}
                </p>
              </div>

              <div className="actions">
                <OutlineButton
                  mini
                  style={{ padding: "0.6rem 2rem" }}
                  onClick={() => setSelectedReqIndex(i)}
                >
                  View Request
                </OutlineButton>
              </div>
            </div>
          ))
        )}
      </div>

      {selectedReqIndex >= 0 && (
        <AddressUpdateDetailsModal
          mutate={mutate}
          req={requests[selectedReqIndex]}
          dismissModal={() => setSelectedReqIndex(-1)}
        />
      )}
    </div>
  );
};

export default AddressUpdateRequestsPage;
